export const LOGOUT_EVENT = 'hedepy:logout'

export const dispatchLogoutEvent = () => {
  window.dispatchEvent(new Event(LOGOUT_EVENT))
}

export const subscribeToLogoutEvent = (onLogout: () => void, options?: Pick<AddEventListenerOptions, 'signal'>) => {
  window.addEventListener(LOGOUT_EVENT, onLogout, options)

  return () => window.removeEventListener(LOGOUT_EVENT, onLogout)
}
